export const DOT_SIZE = 38;
export const GRAPH_LABEL_FONT_SIZE = 10;
export const MATRIX_CHART_SIZE = 200;

export const getGraphTitle = (
  translationBase: string,
  graphId: string,
  labelKey: string
) => `${translationBase}.${graphId}.graphLabels.${labelKey}`;

// substract dot size to avoid dot overflow
export const computePosition = (chartSize: number, value = 0) =>
  (chartSize - DOT_SIZE) * value;

export interface IMatrixGraphProps {
  titleBottomLeft: string;
  titleBottomRight: string;
  titleTopLeft: string;
  titleTopRight: string;
}
